module.exports = __webpack_public_path__ + "static/media/ic_categories_furniture.65374179.svg";